import { Link } from "react-router-dom";
import NewsletterForm from "./NewsletterForm";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050505] py-12 sm:py-16">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-12">
        <div className="grid gap-10 sm:gap-12 lg:grid-cols-[1.2fr_2fr]">
          <div className="max-w-md">
            <div className="font-display text-3xl font-bold tracking-tighter">
              BASELINE<span className="text-[#D4FF00]"> / </span>BREAKDOWN
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/60">
              Editorial coverage of world tennis — longform articles, weekly podcast,
              and original digital content for the obsessed fan.
            </p>
            <div className="mt-8 max-w-sm">
              <NewsletterForm variant="footer" />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-10 sm:grid-cols-4">
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Read</div>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link to="/news" className="hover:text-white">News</Link></li>
                <li><Link to="/category/ATP" className="hover:text-white">ATP</Link></li>
                <li><Link to="/category/WTA" className="hover:text-white">WTA</Link></li>
                <li><Link to="/category/Grand%20Slams" className="hover:text-white">Grand Slams</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Listen</div>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link to="/podcasts" className="hover:text-white">All Episodes</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Watch</div>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link to="/digital" className="hover:text-white">Digital</Link></li>
              </ul>
            </div>
            <div>
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Connect</div>
              <ul className="mt-4 space-y-2 text-sm text-white/70">
                <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs uppercase tracking-[0.2em] text-white/40 md:flex-row">
          <span>© 2026 Baseline Breakdown Media</span>
          <span>Made with topspin.</span>
        </div>
      </div>
    </footer>
  );
}
